import { render, staticRenderFns } from "./AboutContentCN.vue?vue&type=template&id=c3d78eb6&scoped=true"
import script from "./AboutContentCN.vue?vue&type=script&lang=js"
export * from "./AboutContentCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d78eb6",
  null
  
)

export default component.exports